'use client';
import { useEffect, useRef, useState } from 'react';
// -------------- styles -------------------- //
import ArrowDownIcon from '@/assets/icons/ArrowDownNonFixed.svg';
import UKDrawer from '@/components/UKDrawer';
import styles from './TabBar.module.scss';
import CloseIcon from '@/assets/icons/_TCloseIcon.svg';
import { sendClickTrack } from '@/tracks/32520';

interface PropType {
  bannerTrack: any;
  sidebarData: any;
  selected: number;
  setSelected: (val: number) => void;
  handleFetch: (val: string) => void;
  setCurrentSequenceId: (val: string) => void;
}
const TabBar = ({
  sidebarData,
  bannerTrack,
  selected,
  setSelected,
  handleFetch,
  setCurrentSequenceId,
}: PropType) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const buttonRefs = useRef<(HTMLButtonElement | null)[]>([]);

  // -------------- handleSelect function -------------------- //
  const handleSelect = (index: number) => {
    setSelected(index);
    buttonRefs.current[index]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
    handleFetch(sidebarData[index].sequenceId);
  };

  const expoArray = sidebarData && sidebarData.map((items: any) => items.categoryTabName);

  // -------------- useEffect -------------------- //
  useEffect(() => {
    buttonRefs.current[selected]?.scrollIntoView({
      behavior: 'auto', // 默认auto 因为不需要滑动效果
      block: 'nearest',
      inline: 'center',
    });
  }, [selected]);

  return (
    <>
      <div
        className={`${styles.outerContainer}`}
        exptag={'exp|' + bannerTrack.tabExpo}
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        data-exptag-json-param={JSON.stringify({ tabName: expoArray })}
      >
        <div className={styles.container}>
          <div className={styles.gradientOverlay}></div>
          <div className={styles.tabBar}>
            {sidebarData &&
              sidebarData.map((items: any, index: number) => {
                return (
                  <button
                    ref={(el) => {
                      buttonRefs.current[index] = el;
                    }}
                    key={index}
                    style={{ display: 'flex', alignItems: 'center' }}
                    onClick={() => {
                      handleSelect(index);
                      sendClickTrack.Activity_BestSellerHome_Tab({
                        index,
                        tabName: items.categoryTabName,
                      });
                      // 埋点
                      setCurrentSequenceId(items.sequenceId);
                    }}
                  >
                    <span className={`${styles.tablet} ${selected === index && styles.selected}`}>
                      {items.categoryTabName}
                    </span>
                  </button>
                );
              })}
          </div>
        </div>
        <button
          exptag={'exp|' + bannerTrack.tabMoreExpo}
          className={styles.moreButton}
          onClick={() => {
            setIsOpenDrawer(true);
            sendClickTrack.Activity_BestSellerHome_Tab_More(); // 埋点
          }}
        >
          <ArrowDownIcon width={20} height={20} />
        </button>
      </div>

      {isOpenDrawer && (
        <UKDrawer
          title=''
          customTitleButton={true}
          hideTitleButton={true}
          customIconButton={<CloseIcon className={styles.closeIcon} />}
          openDrawer={isOpenDrawer}
          includeBottomBar={false}
          setOpenDrawer={() => {
            setIsOpenDrawer(false);
          }}
          height='92vh'
        >
          <div
            className={styles.drawer}
            exptag={'exp|' + bannerTrack.drawerMoreExpo}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
            data-exptag-json-param={JSON.stringify({ tabName: expoArray })}
          >
            {sidebarData.map((items: any, index: number) => {
              return (
                <button
                  key={index}
                  className={`${styles.drawerBtn} ${selected === index ? styles.selectedBtn : styles.normalBtn}`}
                  onClick={() => {
                    setIsOpenDrawer(false);
                    handleSelect(index);
                    sendClickTrack.Activity_BestSellerHome_More({
                      tabName: items.categoryTabName,
                      index: index,
                    }); // 埋点
                    setCurrentSequenceId(items.sequenceId);
                  }}
                >
                  {items.categoryTabName}
                </button>
              );
            })}
          </div>
        </UKDrawer>
      )}
    </>
  );
};

export default TabBar;
